import { cn } from '@/lib/utils'
import { useStoreI18n } from '@/store'
import { getLogoAltText } from '@/utils'
import { PROJECT } from '@spot'
import Image, { ImageProps } from 'next/image'
import { useMemo } from 'react'

interface Props extends Omit<ImageProps, 'src' | 'alt' | 'width' | 'height'> {
  src?: string
  alt?: string
  width?: number
  height?: number
  isFooter?: boolean
}

const Logo = ({ isFooter, className, alt, width, height }: Props) => {
  const currentLocale = useStoreI18n.use.currentLocale()

  const classes = cn(
    'w-logo-header-width h-logo-header-height',
    isFooter && 'w-logo-footer-width h-logo-footer-height',
    className
  )

  // Generate appropriate alt text for the logo
  const altText = useMemo(() => {
    if (alt !== undefined) {
      return alt
    }
    return getLogoAltText(PROJECT, currentLocale)
  }, [alt, currentLocale])

  switch (PROJECT) {
    case 'obersaxen':
      return (
        <Image
          className={classes}
          aria-label={altText}
          title={altText}
          src={'/logo/obersaxen.png'}
          alt={altText}
          loading="eager"
          width={width || 210}
          height={height || 54}
        />
      )
    default:
      return (
        <Image
          className={classes}
          aria-label={altText}
          title={altText}
          src={'/logo/surselva.svg'}
          alt={altText}
          loading="eager"
          width={width || 136}
          height={height || 32}
        />
      )
  }
}

export default Logo
